<div class="mappings-with-value table-responsive">
  <table class="table table-borderless table-hover table-sm">
    <thead>
    <tr>
      <th scope="col" class="w-8" *ngIf="showSource" (click)="toggleSource()">
        <div i18n="Source">Source Spec/Value</div>
      </th>
      <th scope="col" class="w-16" (click)="toggleSource()">Spec</th>
      <th class="w-auto">
        Value
      </th>
      <th class="w-8">
        Visibility
      </th>
      <th class="w-16">
        Formula
      </th>
      <th class="w-16">
        Constraints
      </th>
      <th class="w-16">
        Alias
      </th>

      <th class="w-4">
        Order
      </th>
      <th></th>
    </tr>
    </thead>
    <tbody *ngFor="let itemProperty of getDefaultMappingLines()">
    <tr *ngIf="itemProperty">
      <td *ngIf="showSource" title="{{getSource(itemProperty)?.SourceType}}/{{ getLineSource(getLine(itemProperty))?.SourceType}}">{{ getSource(itemProperty)?.SourceCode }} / {{ getLineSource(getLine(itemProperty))?.SourceCode }}</td>
      <td>
        <mes-web-property-select name="property-{{itemProperty.Id}}" [items$]="propertyService.getAll$" [entityId]="itemProperty.PropertyId" (entityIdChange)="itemProperty.PropertyId = $event; onMappingChanged($event, itemProperty)"></mes-web-property-select>
      </td>
      <td>
        <mes-web-property-line-edit *ngIf="itemProperty.PropertyId"
          [propertyId]="itemProperty.PropertyId"
          [propertyLine]="getLine(itemProperty)"
          (lineChanged)="onDefaultValueChanged($event.$value, $event.$propertyLine, itemProperty)"></mes-web-property-line-edit>
      </td>
      <td>
        <mes-web-classificator-value-select name="mandatory-{{itemProperty.Id}}" [items$]="classificatorValueService.mandatories$" [entityId]="itemProperty.MandatoryClv" (entityIdChange)="itemProperty.MandatoryClv = $event; onMappingChanged($event, itemProperty)"></mes-web-classificator-value-select>
      </td>
      <td>
        <mes-web-expression-formula cssClass="form-control mx-wx-384 min-wx-128" [expression]="itemProperty.Expression" name="expression-{{itemProperty.Id}}"></mes-web-expression-formula>
      </td>
      <td>
        <mes-web-expression-formula cssClass="form-control mx-wx-384 min-wx-128" [expression]="itemProperty.Constraints" name="constraints-{{itemProperty.Id}}"></mes-web-expression-formula>
      </td>
      <td>
        <div class="input-group">
          <input type="text" class="form-control" name="alias-{{itemProperty.Id}}" [(ngModel)]="itemProperty.Alias" (change)="onMappingChanged($event.target.value, itemProperty)">
          <button class="btn btn-outline-secondary" *ngIf="localizationsEnabled" type="button" id="button-addon2" (click)="itemProperty.$showTranslations = !(itemProperty.$showTranslations || false)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
          </button>
        </div>
        <!--<a class="btn-icon btn-icon-sm bg-primary" ng-if="!itemProperty.LanguageId &amp;&amp; getMappingPerLanguage(itemProperty).length &gt; 0" href="javascript:void(0)" ng-class="{'active': itemProperty.$showTranslations || showLocalizations}" ng-click="itemProperty.$showTranslations = !(itemProperty.$showTranslations || false)"><i class="fa fa-language"></i></a></td>-->
      </td>
      <td>
        <input type="number" class="form-control" name="Sequence-{{itemProperty.Id}}" [(ngModel)]="itemProperty.Sequence" (input)="onMappingChanged($event.target.value, itemProperty)">
      </td>
      <td>
        <a class="btn-icon btn-icon-sm bg-success"
          *ngIf="itemProperty.SourceId !== sourceId || getLine(itemProperty).SourceId !== sourceId"
          href="javascript:void(0)"
          ng-click="overwrite(itemProperty, getLine(itemProperty))"><i class="fa fa-edit"></i></a>
        <a class="btn-icon btn-icon-sm bg-warning" *ngIf="itemProperty.$inherited || getLine(itemProperty).$inherited" href="javascript:void(0)" ng-click="revert(itemProperty, getLine(itemProperty))"><i class="fa fa-undo"></i></a>

        <button type="button" class="btn btn-outline-danger btn-sm" *ngIf="canDelete(itemProperty, getLine(itemProperty))" (click)="delete(itemProperty, getLine(itemProperty))" type="button">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
        </button>
      </td>
    </tr>
    <tr *ngFor="let itemPropertyForLanguage of getMappingPerLanguage(itemProperty)">
      <ng-container *ngIf="showLocalizations || itemProperty.$showTranslations">
        <td *ngIf="showSource"
          title="{{itemPropertyForLanguage.SourceType}}/{{getLine(itemPropertyForLanguage).SourceType}}">{{ itemPropertyForLanguage.SourceCode }} / {{ getLine(itemPropertyForLanguage).SourceCode }} / {{(mandatories | filterBy: ['Id']: itemPropertyForLanguage.MandatoryClv)[0]?.Value }}
        </td>
        <td colspan="2" class="text-end">
          {{(languages | filterBy: ['Id']: (itemPropertyForLanguage.LanguageId || ''))[0]?.Code}}
        </td>
        <td>
          <mes-web-expression-formula name="lang-expression-{{itemPropertyForLanguage.Id}}}" cssClass="form-control min-wx-256" [expression]="itemPropertyForLanguage.Expression"></mes-web-expression-formula>
        </td>
        <td>
          <mes-web-expression-formula name="lang-constraints-{{itemPropertyForLanguage.Id}}}" cssClass="form-control min-wx-256" [expression]="itemPropertyForLanguage.Constraints"></mes-web-expression-formula>
        </td>
        <td>
          <input type="text" class="form-control" name="lang-alias-{{itemPropertyForLanguage.Id}}}" [(ngModel)]="itemPropertyForLanguage.Alias" (change)="onMappingChanged($event.target.value, itemPropertyForLanguage)">
        </td>
        <td></td>
        <td></td>
        <td></td>
      </ng-container>
    </tr>
    </tbody>
  </table>
</div>
